import { defineStore } from "pinia";
import { ICasinoBonusSummary } from "~/types/player/casino-bonus-summary";
import { ICasinoBonusSummaryOld } from "~/types/player/casino-bonus-summary-old";
import { ISportBonusSummary } from "~/types/player/sport-bonus-summary";

interface IBonusses {
	sportBonusSummaries: ISportBonusSummary[] | null;
	casinoBonusSummary: ICasinoBonusSummary | ICasinoBonusSummaryOld | null;
}

export const useBonusses = defineStore({
	id: "bonusses",
	state: (): IBonusses => ({
		sportBonusSummaries: null,
		casinoBonusSummary: null,
	}),
	getters: {
		activeSportBonus: (state): ISportBonusSummary | undefined => {
			return state.sportBonusSummaries?.find((bonus) => bonus.status.toLowerCase() === "active");
		},
	},
});
